var cachedHandoff = null

function mergeQueryString (raw, target) {
  if (!raw) return
  String(raw).replace(/^\?/, '').split('&').forEach(function (pair) {
    if (!pair) return
    var parts = pair.split('=')
    var key = parts[0]
    if (!key) return
    target[decodeURIComponent(key)] = decodeURIComponent(parts[1] || '')
  })
}

export function getQueryParams () {
  var params = {}
  mergeQueryString(window.location.search, params)

  var hash = window.location.hash || ''
  var hashQueryIndex = hash.indexOf('?')
  if (hashQueryIndex >= 0) {
    mergeQueryString(hash.slice(hashQueryIndex), params)
  }

  return params
}

function buildHandoffFromQuery (q) {
  return {
    country: String(q.country || '').toUpperCase(),
    airport: String(q.airport || '').toUpperCase(),
    terminal: String(q.terminal || '').toUpperCase(),
    service: String(q.service || '').toLowerCase()
  }
}

export function snapshotWpHandoffParams () {
  var q = getQueryParams()
  var handoff = buildHandoffFromQuery(q)
  if (handoff.airport) {
    cachedHandoff = handoff
  }
  return handoff
}

export function isEmbedMode () {
  if (window.self !== window.top) return true
  var embed = getQueryParams().embed
  return embed === '1' || embed === 'true'
}

export function parseWpHandoffParams () {
  if (cachedHandoff && cachedHandoff.airport) {
    return cachedHandoff
  }

  var handoff = buildHandoffFromQuery(getQueryParams())
  if (handoff.airport) {
    cachedHandoff = handoff
  }
  return handoff
}

export function mergeWpHandoffParams (overrides) {
  var base = parseWpHandoffParams()
  if (!overrides) return base

  return {
    country: String(overrides.country || base.country || '').toUpperCase(),
    airport: String(overrides.airport || base.airport || '').toUpperCase(),
    terminal: String(overrides.terminal || base.terminal || '').toUpperCase(),
    service: String(overrides.service || base.service || '').toLowerCase()
  }
}



// WEBPACK FOOTER //
// ./src/utils/embedContext.js